module.exports = __webpack_public_path__ + "static/img/text1.594e24a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/text1.png
// module id = knLm
// module chunks = 0